export default __webpack_public_path__ + "static/media/fudge-dai.7fe7ff69.png";